// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3bYNQ","content":"styles_content__11bJ_","selectAll":"styles_selectAll__CI3zP"};